import { DefaultState } from '@src/redux/types'

import * as TYPES from '../constants/actionTypes'
import * as API from '../constants/api'

export const defaultState = () => ({ loading: false, error: null, data: null })

export const initialState: () => {
  [TYPES.QUESTION_ALL]: DefaultState<`${typeof API.QUESTION_ALL}`, 'get'>
  [TYPES.QUESTION_TYPES]: DefaultState<`${typeof API.QUESTION_TYPES}`, 'get'>
  [TYPES.QUESTION_TYPES_COUNTS]: DefaultState<`${typeof API.QUESTION_TYPES_COUNTS}`, 'get'>
} = () => ({
  [TYPES.QUESTION_ALL]: defaultState(),
  [TYPES.QUESTION_TYPES]: defaultState(),
  [TYPES.QUESTION_TYPES_COUNTS]: defaultState(),
})
